import { jsxs as L, jsx as g, Fragment as ye } from "react/jsx-runtime";
import { bG as cr, C as fr, s as dr, o as Dt, r as st, aH as mr, H as hr, q as pr } from "./helpers-458d7e27.js";
import { CheckmarkBackgroundIcon as vr } from "@paypalcorp/pp-react-icons";
import { T as Er } from "./pp-react-text-input.esm-853a9847.js";
import j from "clsx";
import { useRef as gr, useState as ae, useEffect as Cr } from "react";
import { Q as ot } from "./card-renderer-3ad4b108.js";
var je = { exports: {} }, qt = function(t, r) {
  return function() {
    for (var n = new Array(arguments.length), i = 0; i < n.length; i++)
      n[i] = arguments[i];
    return t.apply(r, n);
  };
}, Rr = qt, ke = Object.prototype.toString, He = function(e) {
  return function(t) {
    var r = ke.call(t);
    return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function Q(e) {
  return e = e.toLowerCase(), function(r) {
    return He(r) === e;
  };
}
function Ve(e) {
  return Array.isArray(e);
}
function de(e) {
  return typeof e > "u";
}
function Nr(e) {
  return e !== null && !de(e) && e.constructor !== null && !de(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
var Lt = Q("ArrayBuffer");
function br(e) {
  var t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Lt(e.buffer), t;
}
function wr(e) {
  return typeof e == "string";
}
function yr(e) {
  return typeof e == "number";
}
function Bt(e) {
  return e !== null && typeof e == "object";
}
function le(e) {
  if (He(e) !== "object")
    return !1;
  var t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
var Sr = Q("Date"), Ar = Q("File"), Or = Q("Blob"), Pr = Q("FileList");
function We(e) {
  return ke.call(e) === "[object Function]";
}
function xr(e) {
  return Bt(e) && We(e.pipe);
}
function _r(e) {
  var t = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || ke.call(e) === t || We(e.toString) && e.toString() === t);
}
var Tr = Q("URLSearchParams");
function Dr(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function qr() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function Je(e, t) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), Ve(e))
      for (var r = 0, a = e.length; r < a; r++)
        t.call(null, e[r], r, e);
    else
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && t.call(null, e[n], n, e);
}
function Me() {
  var e = {};
  function t(n, i) {
    le(e[i]) && le(n) ? e[i] = Me(e[i], n) : le(n) ? e[i] = Me({}, n) : Ve(n) ? e[i] = n.slice() : e[i] = n;
  }
  for (var r = 0, a = arguments.length; r < a; r++)
    Je(arguments[r], t);
  return e;
}
function Lr(e, t, r) {
  return Je(t, function(n, i) {
    r && typeof n == "function" ? e[i] = Rr(n, r) : e[i] = n;
  }), e;
}
function Br(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
function Ir(e, t, r, a) {
  e.prototype = Object.create(t.prototype, a), e.prototype.constructor = e, r && Object.assign(e.prototype, r);
}
function Ur(e, t, r) {
  var a, n, i, s = {};
  t = t || {};
  do {
    for (a = Object.getOwnPropertyNames(e), n = a.length; n-- > 0; )
      i = a[n], s[i] || (t[i] = e[i], s[i] = !0);
    e = Object.getPrototypeOf(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}
function $r(e, t, r) {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  var a = e.indexOf(t, r);
  return a !== -1 && a === r;
}
function Fr(e) {
  if (!e)
    return null;
  var t = e.length;
  if (de(t))
    return null;
  for (var r = new Array(t); t-- > 0; )
    r[t] = e[t];
  return r;
}
var Mr = function(e) {
  return function(t) {
    return e && t instanceof e;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), C = {
  isArray: Ve,
  isArrayBuffer: Lt,
  isBuffer: Nr,
  isFormData: _r,
  isArrayBufferView: br,
  isString: wr,
  isNumber: yr,
  isObject: Bt,
  isPlainObject: le,
  isUndefined: de,
  isDate: Sr,
  isFile: Ar,
  isBlob: Or,
  isFunction: We,
  isStream: xr,
  isURLSearchParams: Tr,
  isStandardBrowserEnv: qr,
  forEach: Je,
  merge: Me,
  extend: Lr,
  trim: Dr,
  stripBOM: Br,
  inherits: Ir,
  toFlatObject: Ur,
  kindOf: He,
  kindOfTest: Q,
  endsWith: $r,
  toArray: Fr,
  isTypedArray: Mr,
  isFileList: Pr
}, G = C;
function ut(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var It = function(t, r, a) {
  if (!r)
    return t;
  var n;
  if (a)
    n = a(r);
  else if (G.isURLSearchParams(r))
    n = r.toString();
  else {
    var i = [];
    G.forEach(r, function(c, m) {
      c === null || typeof c > "u" || (G.isArray(c) ? m = m + "[]" : c = [c], G.forEach(c, function(h) {
        G.isDate(h) ? h = h.toISOString() : G.isObject(h) && (h = JSON.stringify(h)), i.push(ut(m) + "=" + ut(h));
      }));
    }), n = i.join("&");
  }
  if (n) {
    var s = t.indexOf("#");
    s !== -1 && (t = t.slice(0, s)), t += (t.indexOf("?") === -1 ? "?" : "&") + n;
  }
  return t;
}, jr = C;
function me() {
  this.handlers = [];
}
me.prototype.use = function(t, r, a) {
  return this.handlers.push({
    fulfilled: t,
    rejected: r,
    synchronous: a ? a.synchronous : !1,
    runWhen: a ? a.runWhen : null
  }), this.handlers.length - 1;
};
me.prototype.eject = function(t) {
  this.handlers[t] && (this.handlers[t] = null);
};
me.prototype.forEach = function(t) {
  jr.forEach(this.handlers, function(a) {
    a !== null && t(a);
  });
};
var kr = me, Hr = C, Vr = function(t, r) {
  Hr.forEach(t, function(n, i) {
    i !== r && i.toUpperCase() === r.toUpperCase() && (t[r] = n, delete t[i]);
  });
}, Ut = C;
function Y(e, t, r, a, n) {
  Error.call(this), this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), a && (this.request = a), n && (this.response = n);
}
Ut.inherits(Y, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var $t = Y.prototype, Ft = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
  // eslint-disable-next-line func-names
].forEach(function(e) {
  Ft[e] = { value: e };
});
Object.defineProperties(Y, Ft);
Object.defineProperty($t, "isAxiosError", { value: !0 });
Y.from = function(e, t, r, a, n, i) {
  var s = Object.create($t);
  return Ut.toFlatObject(e, s, function(c) {
    return c !== Error.prototype;
  }), Y.call(s, e.message, t, r, a, n), s.name = e.name, i && Object.assign(s, i), s;
};
var ee = Y, Mt = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, x = C;
function Wr(e, t) {
  t = t || new FormData();
  var r = [];
  function a(i) {
    return i === null ? "" : x.isDate(i) ? i.toISOString() : x.isArrayBuffer(i) || x.isTypedArray(i) ? typeof Blob == "function" ? new Blob([i]) : Buffer.from(i) : i;
  }
  function n(i, s) {
    if (x.isPlainObject(i) || x.isArray(i)) {
      if (r.indexOf(i) !== -1)
        throw Error("Circular reference detected in " + s);
      r.push(i), x.forEach(i, function(c, m) {
        if (!x.isUndefined(c)) {
          var d = s ? s + "." + m : m, h;
          if (c && !s && typeof c == "object") {
            if (x.endsWith(m, "{}"))
              c = JSON.stringify(c);
            else if (x.endsWith(m, "[]") && (h = x.toArray(c))) {
              h.forEach(function(l) {
                !x.isUndefined(l) && t.append(d, a(l));
              });
              return;
            }
          }
          n(c, d);
        }
      }), r.pop();
    } else
      t.append(s, a(i));
  }
  return n(e), t;
}
var jt = Wr, Se, lt;
function Jr() {
  if (lt)
    return Se;
  lt = 1;
  var e = ee;
  return Se = function(r, a, n) {
    var i = n.config.validateStatus;
    !n.status || !i || i(n.status) ? r(n) : a(new e(
      "Request failed with status code " + n.status,
      [e.ERR_BAD_REQUEST, e.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
      n.config,
      n.request,
      n
    ));
  }, Se;
}
var Ae, ct;
function Xr() {
  if (ct)
    return Ae;
  ct = 1;
  var e = C;
  return Ae = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(a, n, i, s, o, c) {
          var m = [];
          m.push(a + "=" + encodeURIComponent(n)), e.isNumber(i) && m.push("expires=" + new Date(i).toGMTString()), e.isString(s) && m.push("path=" + s), e.isString(o) && m.push("domain=" + o), c === !0 && m.push("secure"), document.cookie = m.join("; ");
        },
        read: function(a) {
          var n = document.cookie.match(new RegExp("(^|;\\s*)(" + a + ")=([^;]*)"));
          return n ? decodeURIComponent(n[3]) : null;
        },
        remove: function(a) {
          this.write(a, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), Ae;
}
var Qr = function(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}, zr = function(t, r) {
  return r ? t.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : t;
}, Gr = Qr, Kr = zr, kt = function(t, r) {
  return t && !Gr(r) ? Kr(t, r) : r;
}, Oe, ft;
function Yr() {
  if (ft)
    return Oe;
  ft = 1;
  var e = C, t = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return Oe = function(a) {
    var n = {}, i, s, o;
    return a && e.forEach(a.split(`
`), function(m) {
      if (o = m.indexOf(":"), i = e.trim(m.substr(0, o)).toLowerCase(), s = e.trim(m.substr(o + 1)), i) {
        if (n[i] && t.indexOf(i) >= 0)
          return;
        i === "set-cookie" ? n[i] = (n[i] ? n[i] : []).concat([s]) : n[i] = n[i] ? n[i] + ", " + s : s;
      }
    }), n;
  }, Oe;
}
var Pe, dt;
function Zr() {
  if (dt)
    return Pe;
  dt = 1;
  var e = C;
  return Pe = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var r = /(msie|trident)/i.test(navigator.userAgent), a = document.createElement("a"), n;
      function i(s) {
        var o = s;
        return r && (a.setAttribute("href", o), o = a.href), a.setAttribute("href", o), {
          href: a.href,
          protocol: a.protocol ? a.protocol.replace(/:$/, "") : "",
          host: a.host,
          search: a.search ? a.search.replace(/^\?/, "") : "",
          hash: a.hash ? a.hash.replace(/^#/, "") : "",
          hostname: a.hostname,
          port: a.port,
          pathname: a.pathname.charAt(0) === "/" ? a.pathname : "/" + a.pathname
        };
      }
      return n = i(window.location.href), function(o) {
        var c = e.isString(o) ? i(o) : o;
        return c.protocol === n.protocol && c.host === n.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), Pe;
}
var xe, mt;
function he() {
  if (mt)
    return xe;
  mt = 1;
  var e = ee, t = C;
  function r(a) {
    e.call(this, a ?? "canceled", e.ERR_CANCELED), this.name = "CanceledError";
  }
  return t.inherits(r, e, {
    __CANCEL__: !0
  }), xe = r, xe;
}
var _e, ht;
function en() {
  return ht || (ht = 1, _e = function(t) {
    var r = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
    return r && r[1] || "";
  }), _e;
}
var Te, pt;
function vt() {
  if (pt)
    return Te;
  pt = 1;
  var e = C, t = Jr(), r = Xr(), a = It, n = kt, i = Yr(), s = Zr(), o = Mt, c = ee, m = he(), d = en();
  return Te = function(l) {
    return new Promise(function(ge, _) {
      var U = l.data, $ = l.headers, S = l.responseType, y;
      function ie() {
        l.cancelToken && l.cancelToken.unsubscribe(y), l.signal && l.signal.removeEventListener("abort", y);
      }
      e.isFormData(U) && e.isStandardBrowserEnv() && delete $["Content-Type"];
      var f = new XMLHttpRequest();
      if (l.auth) {
        var F = l.auth.username || "", Ce = l.auth.password ? unescape(encodeURIComponent(l.auth.password)) : "";
        $.Authorization = "Basic " + btoa(F + ":" + Ce);
      }
      var T = n(l.baseURL, l.url);
      f.open(l.method.toUpperCase(), a(T, l.params, l.paramsSerializer), !0), f.timeout = l.timeout;
      function H() {
        if (f) {
          var b = "getAllResponseHeaders" in f ? i(f.getAllResponseHeaders()) : null, D = !S || S === "text" || S === "json" ? f.responseText : f.response, B = {
            data: D,
            status: f.status,
            statusText: f.statusText,
            headers: b,
            config: l,
            request: f
          };
          t(function(W) {
            ge(W), ie();
          }, function(W) {
            _(W), ie();
          }, B), f = null;
        }
      }
      if ("onloadend" in f ? f.onloadend = H : f.onreadystatechange = function() {
        !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(H);
      }, f.onabort = function() {
        f && (_(new c("Request aborted", c.ECONNABORTED, l, f)), f = null);
      }, f.onerror = function() {
        _(new c("Network Error", c.ERR_NETWORK, l, f, f)), f = null;
      }, f.ontimeout = function() {
        var D = l.timeout ? "timeout of " + l.timeout + "ms exceeded" : "timeout exceeded", B = l.transitional || o;
        l.timeoutErrorMessage && (D = l.timeoutErrorMessage), _(new c(
          D,
          B.clarifyTimeoutError ? c.ETIMEDOUT : c.ECONNABORTED,
          l,
          f
        )), f = null;
      }, e.isStandardBrowserEnv()) {
        var se = (l.withCredentials || s(T)) && l.xsrfCookieName ? r.read(l.xsrfCookieName) : void 0;
        se && ($[l.xsrfHeaderName] = se);
      }
      "setRequestHeader" in f && e.forEach($, function(D, B) {
        typeof U > "u" && B.toLowerCase() === "content-type" ? delete $[B] : f.setRequestHeader(B, D);
      }), e.isUndefined(l.withCredentials) || (f.withCredentials = !!l.withCredentials), S && S !== "json" && (f.responseType = l.responseType), typeof l.onDownloadProgress == "function" && f.addEventListener("progress", l.onDownloadProgress), typeof l.onUploadProgress == "function" && f.upload && f.upload.addEventListener("progress", l.onUploadProgress), (l.cancelToken || l.signal) && (y = function(b) {
        f && (_(!b || b && b.type ? new m() : b), f.abort(), f = null);
      }, l.cancelToken && l.cancelToken.subscribe(y), l.signal && (l.signal.aborted ? y() : l.signal.addEventListener("abort", y))), U || (U = null);
      var V = d(T);
      if (V && ["http", "https", "file"].indexOf(V) === -1) {
        _(new c("Unsupported protocol " + V + ":", c.ERR_BAD_REQUEST, l));
        return;
      }
      f.send(U);
    });
  }, Te;
}
var De, Et;
function tn() {
  return Et || (Et = 1, De = null), De;
}
var E = C, gt = Vr, Ct = ee, rn = Mt, nn = jt, an = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function Rt(e, t) {
  !E.isUndefined(e) && E.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
}
function sn() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (e = vt()), e;
}
function on(e, t, r) {
  if (E.isString(e))
    try {
      return (t || JSON.parse)(e), E.trim(e);
    } catch (a) {
      if (a.name !== "SyntaxError")
        throw a;
    }
  return (r || JSON.stringify)(e);
}
var pe = {
  transitional: rn,
  adapter: sn(),
  transformRequest: [function(t, r) {
    if (gt(r, "Accept"), gt(r, "Content-Type"), E.isFormData(t) || E.isArrayBuffer(t) || E.isBuffer(t) || E.isStream(t) || E.isFile(t) || E.isBlob(t))
      return t;
    if (E.isArrayBufferView(t))
      return t.buffer;
    if (E.isURLSearchParams(t))
      return Rt(r, "application/x-www-form-urlencoded;charset=utf-8"), t.toString();
    var a = E.isObject(t), n = r && r["Content-Type"], i;
    if ((i = E.isFileList(t)) || a && n === "multipart/form-data") {
      var s = this.env && this.env.FormData;
      return nn(i ? { "files[]": t } : t, s && new s());
    } else if (a || n === "application/json")
      return Rt(r, "application/json"), on(t);
    return t;
  }],
  transformResponse: [function(t) {
    var r = this.transitional || pe.transitional, a = r && r.silentJSONParsing, n = r && r.forcedJSONParsing, i = !a && this.responseType === "json";
    if (i || n && E.isString(t) && t.length)
      try {
        return JSON.parse(t);
      } catch (s) {
        if (i)
          throw s.name === "SyntaxError" ? Ct.from(s, Ct.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: tn()
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
E.forEach(["delete", "get", "head"], function(t) {
  pe.headers[t] = {};
});
E.forEach(["post", "put", "patch"], function(t) {
  pe.headers[t] = E.merge(an);
});
var Xe = pe, un = C, ln = Xe, cn = function(t, r, a) {
  var n = this || ln;
  return un.forEach(a, function(s) {
    t = s.call(n, t, r);
  }), t;
}, qe, Nt;
function Ht() {
  return Nt || (Nt = 1, qe = function(t) {
    return !!(t && t.__CANCEL__);
  }), qe;
}
var bt = C, Le = cn, fn = Ht(), dn = Xe, mn = he();
function Be(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new mn();
}
var hn = function(t) {
  Be(t), t.headers = t.headers || {}, t.data = Le.call(
    t,
    t.data,
    t.headers,
    t.transformRequest
  ), t.headers = bt.merge(
    t.headers.common || {},
    t.headers[t.method] || {},
    t.headers
  ), bt.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(n) {
      delete t.headers[n];
    }
  );
  var r = t.adapter || dn.adapter;
  return r(t).then(function(n) {
    return Be(t), n.data = Le.call(
      t,
      n.data,
      n.headers,
      t.transformResponse
    ), n;
  }, function(n) {
    return fn(n) || (Be(t), n && n.response && (n.response.data = Le.call(
      t,
      n.response.data,
      n.response.headers,
      t.transformResponse
    ))), Promise.reject(n);
  });
}, w = C, Vt = function(t, r) {
  r = r || {};
  var a = {};
  function n(d, h) {
    return w.isPlainObject(d) && w.isPlainObject(h) ? w.merge(d, h) : w.isPlainObject(h) ? w.merge({}, h) : w.isArray(h) ? h.slice() : h;
  }
  function i(d) {
    if (w.isUndefined(r[d])) {
      if (!w.isUndefined(t[d]))
        return n(void 0, t[d]);
    } else
      return n(t[d], r[d]);
  }
  function s(d) {
    if (!w.isUndefined(r[d]))
      return n(void 0, r[d]);
  }
  function o(d) {
    if (w.isUndefined(r[d])) {
      if (!w.isUndefined(t[d]))
        return n(void 0, t[d]);
    } else
      return n(void 0, r[d]);
  }
  function c(d) {
    if (d in r)
      return n(t[d], r[d]);
    if (d in t)
      return n(void 0, t[d]);
  }
  var m = {
    url: s,
    method: s,
    data: s,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: c
  };
  return w.forEach(Object.keys(t).concat(Object.keys(r)), function(h) {
    var l = m[h] || i, R = l(h);
    w.isUndefined(R) && l !== c || (a[h] = R);
  }), a;
}, Ie, wt;
function Wt() {
  return wt || (wt = 1, Ie = {
    version: "0.27.2"
  }), Ie;
}
var pn = Wt().version, k = ee, Qe = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, t) {
  Qe[e] = function(a) {
    return typeof a === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var yt = {};
Qe.transitional = function(t, r, a) {
  function n(i, s) {
    return "[Axios v" + pn + "] Transitional option '" + i + "'" + s + (a ? ". " + a : "");
  }
  return function(i, s, o) {
    if (t === !1)
      throw new k(
        n(s, " has been removed" + (r ? " in " + r : "")),
        k.ERR_DEPRECATED
      );
    return r && !yt[s] && (yt[s] = !0, console.warn(
      n(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(i, s, o) : !0;
  };
};
function vn(e, t, r) {
  if (typeof e != "object")
    throw new k("options must be an object", k.ERR_BAD_OPTION_VALUE);
  for (var a = Object.keys(e), n = a.length; n-- > 0; ) {
    var i = a[n], s = t[i];
    if (s) {
      var o = e[i], c = o === void 0 || s(o, i, e);
      if (c !== !0)
        throw new k("option " + i + " must be " + c, k.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new k("Unknown option " + i, k.ERR_BAD_OPTION);
  }
}
var En = {
  assertOptions: vn,
  validators: Qe
}, Jt = C, gn = It, St = kr, At = hn, ve = Vt, Cn = kt, Xt = En, K = Xt.validators;
function Z(e) {
  this.defaults = e, this.interceptors = {
    request: new St(),
    response: new St()
  };
}
Z.prototype.request = function(t, r) {
  typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = ve(this.defaults, r), r.method ? r.method = r.method.toLowerCase() : this.defaults.method ? r.method = this.defaults.method.toLowerCase() : r.method = "get";
  var a = r.transitional;
  a !== void 0 && Xt.assertOptions(a, {
    silentJSONParsing: K.transitional(K.boolean),
    forcedJSONParsing: K.transitional(K.boolean),
    clarifyTimeoutError: K.transitional(K.boolean)
  }, !1);
  var n = [], i = !0;
  this.interceptors.request.forEach(function(R) {
    typeof R.runWhen == "function" && R.runWhen(r) === !1 || (i = i && R.synchronous, n.unshift(R.fulfilled, R.rejected));
  });
  var s = [];
  this.interceptors.response.forEach(function(R) {
    s.push(R.fulfilled, R.rejected);
  });
  var o;
  if (!i) {
    var c = [At, void 0];
    for (Array.prototype.unshift.apply(c, n), c = c.concat(s), o = Promise.resolve(r); c.length; )
      o = o.then(c.shift(), c.shift());
    return o;
  }
  for (var m = r; n.length; ) {
    var d = n.shift(), h = n.shift();
    try {
      m = d(m);
    } catch (l) {
      h(l);
      break;
    }
  }
  try {
    o = At(m);
  } catch (l) {
    return Promise.reject(l);
  }
  for (; s.length; )
    o = o.then(s.shift(), s.shift());
  return o;
};
Z.prototype.getUri = function(t) {
  t = ve(this.defaults, t);
  var r = Cn(t.baseURL, t.url);
  return gn(r, t.params, t.paramsSerializer);
};
Jt.forEach(["delete", "get", "head", "options"], function(t) {
  Z.prototype[t] = function(r, a) {
    return this.request(ve(a || {}, {
      method: t,
      url: r,
      data: (a || {}).data
    }));
  };
});
Jt.forEach(["post", "put", "patch"], function(t) {
  function r(a) {
    return function(i, s, o) {
      return this.request(ve(o || {}, {
        method: t,
        headers: a ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: s
      }));
    };
  }
  Z.prototype[t] = r(), Z.prototype[t + "Form"] = r(!0);
});
var Rn = Z, Ue, Ot;
function Nn() {
  if (Ot)
    return Ue;
  Ot = 1;
  var e = he();
  function t(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var a;
    this.promise = new Promise(function(s) {
      a = s;
    });
    var n = this;
    this.promise.then(function(i) {
      if (n._listeners) {
        var s, o = n._listeners.length;
        for (s = 0; s < o; s++)
          n._listeners[s](i);
        n._listeners = null;
      }
    }), this.promise.then = function(i) {
      var s, o = new Promise(function(c) {
        n.subscribe(c), s = c;
      }).then(i);
      return o.cancel = function() {
        n.unsubscribe(s);
      }, o;
    }, r(function(s) {
      n.reason || (n.reason = new e(s), a(n.reason));
    });
  }
  return t.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, t.prototype.subscribe = function(a) {
    if (this.reason) {
      a(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(a) : this._listeners = [a];
  }, t.prototype.unsubscribe = function(a) {
    if (this._listeners) {
      var n = this._listeners.indexOf(a);
      n !== -1 && this._listeners.splice(n, 1);
    }
  }, t.source = function() {
    var a, n = new t(function(s) {
      a = s;
    });
    return {
      token: n,
      cancel: a
    };
  }, Ue = t, Ue;
}
var $e, Pt;
function bn() {
  return Pt || (Pt = 1, $e = function(t) {
    return function(a) {
      return t.apply(null, a);
    };
  }), $e;
}
var Fe, xt;
function wn() {
  if (xt)
    return Fe;
  xt = 1;
  var e = C;
  return Fe = function(r) {
    return e.isObject(r) && r.isAxiosError === !0;
  }, Fe;
}
var _t = C, yn = qt, ce = Rn, Sn = Vt, An = Xe;
function Qt(e) {
  var t = new ce(e), r = yn(ce.prototype.request, t);
  return _t.extend(r, ce.prototype, t), _t.extend(r, t), r.create = function(n) {
    return Qt(Sn(e, n));
  }, r;
}
var N = Qt(An);
N.Axios = ce;
N.CanceledError = he();
N.CancelToken = Nn();
N.isCancel = Ht();
N.VERSION = Wt().version;
N.toFormData = jt;
N.AxiosError = ee;
N.Cancel = N.CanceledError;
N.all = function(t) {
  return Promise.all(t);
};
N.spread = bn();
N.isAxiosError = wn();
je.exports = N;
je.exports.default = N;
var On = je.exports, Pn = On;
const Tt = /* @__PURE__ */ cr(Pn);
var fe = /* @__PURE__ */ ((e) => (e.incentive_eligible = "incentive_eligible", e.account_creation_eligible = "account_creation_eligible", e.account_creation_ineligible = "account_creation_ineligible", e))(fe || {});
const xn = (e) => {
  var n, i, s, o, c, m;
  let t = (n = e.target) == null ? void 0 : n.selectionStart;
  const r = (i = e.target) == null ? void 0 : i.value.replace(/[^\d]/g, ""), a = (r == null ? void 0 : r.length) || 0;
  return (s = e.target) != null && s.value ? (a <= 4 ? t = e.target.selectionStart + 3 : ((c = e.target) == null ? void 0 : c.selectionStart) === 5 ? t = 7 : ((m = e.target) == null ? void 0 : m.selectionStart) === 10 && (t = 11), a < 4 ? [r, t] : a < 7 ? [
    `(${r.slice(0, 3)}) ${r.slice(3)}`,
    t
  ] : [
    `(${r.slice(0, 3)}) ${r.slice(
      3,
      6
    )}-${r.slice(6, 10)}`,
    t
  ]) : [(o = e.target) == null ? void 0 : o.value, t];
};
const Ee = "AppDownloadGroup", p = new fr(Ee), _n = ({ text: e }) => e ? /* @__PURE__ */ g(Dt, { as: "p", className: p.getElementClassName("text"), children: e }) : null, Tn = ({
  ctaMobile: e,
  analyticsCompName: t,
  buttonGroupWrapper: r
}) => e ? /* @__PURE__ */ g(
  r,
  {
    analyticsCompName: t,
    className: p.getElementClassName("ctaGroup"),
    ...e
  }
) : null, Dn = ({
  disclosureType: e,
  analyticsCompName: t,
  disclosureWrapper: r
}) => e ? /* @__PURE__ */ g(
  r,
  {
    ...e,
    className: p.getElementClassName("disclaimer"),
    analyticsCompName: t,
    analyticsTextSection: "disclaimer"
  }
) : null, qn = (e) => e ? /* @__PURE__ */ L("div", { className: p.getElementClassName("successMsgContainer"), children: [
  /* @__PURE__ */ g(
    vr,
    {
      size: "sm",
      className: p.getElementClassName("successIcon")
    }
  ),
  /* @__PURE__ */ g(
    Dt,
    {
      as: "p",
      className: p.getElementClassName("successMsgText"),
      children: e
    }
  )
] }) : null, zt = ({
  text: e = "",
  imageUrl: t = "",
  imageAltText: r = "",
  phoneNumberText: a = "",
  className: n = "",
  disclosureType: i,
  alignment: s = "Start",
  cta: o,
  ctaSms: c,
  ctaMobile: m,
  successFallbackMessage: d = "",
  errorFallbackMessage: h = "",
  invalidFallbackMessage: l = "",
  accountCreationEligibleFallback: R = "",
  accountCreationIneligibleFallback: ge = "",
  intent: _,
  src: U,
  tsrce: $,
  variant: S = "QR and SMS",
  analyticsCompName: y = Ee,
  buttonGroupWrapper: ie,
  disclosureWrapper: f,
  dataQrUrl: F,
  ...Ce
}) => {
  const T = gr(null), [H, se] = ae(""), [V, b] = ae(0), [D, B] = ae(""), [te, W] = ae(""), [ze, z] = ae(!1), q = S === "QR and SMS", Gt = q && !D, Kt = S === "QR code only" && !o, Ge = s === "Start" || s === "End", Yt = q && !m, Zt = j(
    p.getComponentClassName(),
    p.getPropsValueClassName("variant", S),
    q && !F && !t && p.getPropsValueClassName("noImageVariant", S),
    n
  ), Re = j(
    p.getElementClassName("row"),
    p.getPropsValueClassName("rowAlign", s),
    Yt && p.getElementClassName("rowNoCtaMobile")
  ), Ne = _n({ text: e }), Ke = Dn({
    disclosureType: i,
    analyticsCompName: y,
    disclosureWrapper: f
  }), Ye = Tn({
    ctaMobile: m,
    analyticsCompName: y,
    buttonGroupWrapper: ie
  }), { requestor: { csrfToken: oe = "" } = {} } = dr();
  Cr(() => {
    T != null && T.current && (T.current.selectionStart = V, T.current.selectionEnd = V);
  }, [V]);
  const A = (v, J) => {
    W(v), B(J);
  }, er = (v) => {
    const [J, be] = xn(
      v
    );
    se(J), b(be), te !== "" && W("");
  }, tr = (v) => v === fe.account_creation_eligible ? R : v === fe.account_creation_ineligible ? ge : "", Ze = () => H.replace(/[^\d]/g, "").length !== 10 ? (W(l), !1) : !0, rr = (v) => {
    if (!Ze())
      return;
    v.preventDefault(), A("", ""), z(!0);
    const J = "/mobile-app/api/sms", we = {
      phoneNumber: H.replace(/[^\d]/g, ""),
      _csrf: oe,
      intent: _ || "",
      src: U || "",
      tsrce: $ || ""
    };
    Tt({
      method: "POST",
      data: we,
      headers: {
        "X-CSRF-Token": oe,
        "X-Requested-With": "XMLHttpRequest"
      },
      url: J,
      validateStatus(u) {
        return u >= 200 && u < 300 || u >= 400 && u < 500;
      }
    }).then((u) => {
      var I, O, P, re, ne;
      if (z(!1), ((I = u == null ? void 0 : u.data) == null ? void 0 : I.statusCode) === 400 || (u == null ? void 0 : u.status) === 400) {
        const M = ((O = u == null ? void 0 : u.data) == null ? void 0 : O.message) || l;
        A(M, "");
      } else if (((P = u == null ? void 0 : u.data) == null ? void 0 : P.statusCode) > 400 || (u == null ? void 0 : u.status) > 400) {
        const M = ((re = u == null ? void 0 : u.data) == null ? void 0 : re.message) || h;
        A(M, "");
      } else {
        const M = ((ne = u == null ? void 0 : u.data) == null ? void 0 : ne.message) || d;
        A("", M);
      }
    }).catch((u) => {
      var O, P;
      z(!1);
      const I = ((P = (O = u == null ? void 0 : u.response) == null ? void 0 : O.data) == null ? void 0 : P.message) || h;
      A(I, "");
    });
  }, nr = (v) => {
    if (!Ze())
      return;
    v.preventDefault(), A("", ""), z(!0);
    const J = "/cgp/api/app-download/signup-incentive", we = {
      phoneNumber: H.replace(/[^\d]/g, ""),
      _csrf: oe,
      personalizationTouchpoints: [
        {
          code: "growth_incentive",
          intent: "incentive_signup",
          message_count: 1
        }
      ],
      intent: _ || "",
      src: U || "",
      tsrce: $ || ""
    };
    Tt({
      method: "POST",
      data: we,
      headers: {
        "X-CSRF-Token": oe,
        "X-Requested-With": "XMLHttpRequest"
      },
      url: J,
      validateStatus(u) {
        return u >= 200 && u < 300 || u >= 400 && u < 500;
      }
    }).then((u) => {
      var I, O, P, re, ne, M;
      if (z(!1), ((I = u == null ? void 0 : u.data) == null ? void 0 : I.statusCode) === 400 || (u == null ? void 0 : u.status) === 400) {
        const X = ((O = u == null ? void 0 : u.data) == null ? void 0 : O.message) || l;
        A(X, "");
      } else if (u.data.statusCode > 400 || u.status > 400) {
        const X = ((P = u == null ? void 0 : u.data) == null ? void 0 : P.message) || h;
        A(X, "");
      } else if (((re = u == null ? void 0 : u.data) == null ? void 0 : re.decision) === fe.incentive_eligible) {
        const X = u.data.message || d;
        A("", X);
      } else {
        const X = tr(
          ((ne = u == null ? void 0 : u.data) == null ? void 0 : ne.decision) || ""
        ), lr = ((M = u == null ? void 0 : u.data) == null ? void 0 : M.message) || X || h;
        A(lr, "");
      }
    }).catch((u) => {
      var O, P;
      z(!1);
      const I = ((P = (O = u == null ? void 0 : u.response) == null ? void 0 : O.data) == null ? void 0 : P.message) || h;
      A(I, "");
    });
  }, et = (v) => {
    _ === "incentive_signup" ? nr(v) : rr(v);
  }, ar = (v) => {
    v.key === "Enter" && et(v);
  }, tt = () => /* @__PURE__ */ g("div", { className: p.getElementClassName("phoneInputWrapper"), children: /* @__PURE__ */ g(
    Er,
    {
      ref: T,
      name: y,
      type: "tel",
      className: p.getElementClassName("phoneInput"),
      value: H,
      onChange: (v) => er(v),
      onKeyPress: (v) => ar(v),
      error: !!te,
      label: a,
      errorText: te
    }
  ) }), ue = () => /* @__PURE__ */ L("div", { className: p.getElementClassName("ctaDesktopContainer"), children: [
    Gt && c && /* @__PURE__ */ g(
      st,
      {
        analyticsCompName: y,
        className: j(
          p.getElementClassName("ctaSms"),
          ze && p.getElementClassName("ctaSmsLoading")
        ),
        onClick: (v) => ze ? !1 : et(v),
        ...c,
        url: "#!",
        as: "button"
      }
    ),
    o && /* @__PURE__ */ g(
      st,
      {
        className: p.getElementClassName("cta"),
        analyticsCompName: y,
        ...o
      }
    )
  ] }), ir = () => F || s === "Center" ? /* @__PURE__ */ L(ye, { children: [
    /* @__PURE__ */ g("div", { className: p.getElementClassName("phoneInputRow"), children: tt() }),
    ue()
  ] }) : /* @__PURE__ */ L("div", { className: p.getElementClassName("phoneInputRow"), children: [
    tt(),
    ue()
  ] }), rt = () => q ? D ? qn(D) : ir() : null, nt = () => /* @__PURE__ */ L(
    "div",
    {
      className: j(
        p.getElementClassName("qrRow"),
        p.getPropsValueClassName("qrRow", S)
      ),
      children: [
        /* @__PURE__ */ g(
          ot,
          {
            className: p.getElementClassName("imageCol"),
            variant: "large",
            dataUrl: F,
            fallbackImageUrl: t,
            imageAltText: r
          }
        ),
        /* @__PURE__ */ L(
          "div",
          {
            className: j(
              p.getElementClassName("contentCol"),
              !F && !t && p.getElementClassName("noImageContentCol")
            ),
            children: [
              rt(),
              !q && ue()
            ]
          }
        )
      ]
    }
  ), sr = () => /* @__PURE__ */ L(ye, { children: [
    Ne,
    nt(),
    Ke
  ] }), or = () => /* @__PURE__ */ L(ye, { children: [
    Ne,
    nt()
  ] }), at = () => /* @__PURE__ */ g("div", { className: Re, children: /* @__PURE__ */ g(
    "div",
    {
      className: j(
        p.getElementClassName("col"),
        !F && !t && p.getElementClassName("noImageCol")
      ),
      children: q ? sr() : or()
    }
  ) }), it = () => /* @__PURE__ */ g("div", { className: Re, children: /* @__PURE__ */ L(
    "div",
    {
      className: j(
        p.getElementClassName("col"),
        Kt && p.getElementClassName("noCtaCol")
      ),
      children: [
        Ne,
        /* @__PURE__ */ g(
          ot,
          {
            variant: "large",
            dataUrl: F,
            fallbackImageUrl: t,
            imageAltText: r,
            className: p.getElementClassName("imageContainer")
          }
        ),
        q && rt(),
        !q && ue(),
        q && Ke
      ]
    }
  ) }), ur = () => /* @__PURE__ */ g(
    "div",
    {
      className: j(
        Re,
        p.getElementClassName("rowMobile")
      ),
      children: Ye
    }
  );
  return /* @__PURE__ */ L("div", { className: Zt, ...Ce, children: [
    q ? (() => Ge ? at() : it())() : (() => Ge && o ? at() : it())(),
    Ye && ur()
  ] });
};
zt.displayName = Ee;
const Ln = ({
  isAnimated: e = !1,
  ...t
}) => /* @__PURE__ */ g(
  zt,
  {
    buttonGroupWrapper: mr,
    disclosureWrapper: hr,
    imageFrameWrapper: pr,
    imageFrameProps: {
      isAnimated: e
    },
    ...t
  }
);
Ln.displayName = Ee;
export {
  zt as A,
  Ln as a,
  Tt as b
};
//# sourceMappingURL=AppDownload-79ac7787.js.map
